export default {
    loading: '加载中...',
    add: '新增',
    delete: '删除',
    edit: '修改',
    query: '查询',
    export: '导出',
    handle: '操作',
    back: '返回',
    confirm: '确定',
    cancel: '取消',
    clear: '清除',
    close: '关闭',
    createTime: '创建时间',
    updateTime: '更新时间',
    required: '必填项不能为空',
    app: {
        title: '北洋物联Iot养老服务平台',
        description:
            '全球领先的养老物联网产品及智能家居解决方案提供商，提供健康养老领域的智慧物联、软硬件集成、数据整合及智能家居完整解决方案，请尽情地感受科技为您带来的愉悦与便捷，我们伴您一起乐享人生。！',
        logoText: '北洋物联Iot',
        miniLogoText: 'PYIot',
        username: '用户名',
        password: '密码',
        captcha: '验证码',
        signIn: '登录',
        register: '用户注册',
        accountSignIn: '账号密码登录',
        mobileSignIn: '手机短信登录',
        mobile: '手机号',
        signOut: '退出',
        large: '大型',
        default: '默认',
        small: '小型',
        close: '关闭',
        refresh: '刷新',
        closeOthers: '关闭其它',
        refreshAll: '刷新全部',
        closeAll: '关闭全部'
    },
    settings: {
        title: '布局设置',
        sidebarDark: '暗色侧边栏',
        sidebarLight: '亮色侧边栏',
        navbarLight: '亮色顶栏',
        navbarTheme: '主题色顶栏',
        layout: '布局切换',
        vertical: '纵向',
        columns: '分栏',
        transverse: '横向',
        interface: '界面设置',
        dark: '开启暗黑模式',
        uniqueOpened: '侧栏排他展开',
        msgNotify: '消息通知',
        logo: '开启LOGO',
        breadcrumb: '开启面包屑',
        tabs: '开启标签页',
        tabsCache: '开启标签页缓存',
        tabsStyle: '标签页风格',
        tips: '设置之后仅是临时生效，要想永久生效，需点击下方的 "复制配置" 按钮，将配置替换到 store/theme/config.ts 中。',
        copyConfig: '复制配置',
        reset: '恢复默认',
        copySuc: '复制成功',
        style1: '风格1',
        style2: '风格2'
    },
    error: {
        email: '邮箱格式不正确',
        password: '密码不能小于{len}位数'
    },
    router: {
        home: '首页',
        profilePassword: '修改密码'
    }
}
